export default __webpack_public_path__ + "static/flipImg1-9b93e01ce3cbef17f8de0c1f35f4483f.webp";